import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import OrganizationService from '@forwardflow/services/OrganizationService'

import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export const useOrganizationAvailableForInvitationUsers = (
   queryParams: PaginationQueryParams
) => {
   const response = useSWR(
      [
         QUERY_KEYS.ORGANIZATION_AVAILABLE_FOR_INVITATION_USERS,
         { ...queryParams },
      ],
      () =>
         OrganizationService.getOrganizationAvaiableForInvitationUsersLists(
            queryParams
         ),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
   }
}
